import {useRef} from '@wordpress/element';
import ScrollAnimate from './hooks/scroll-animation';
import Badge from "./badge";

const Experience = ({ specialTag, experiences }) => {
    const thisDivs = useRef([]);
    ScrollAnimate(thisDivs);
  /**
   * Make the array to easy to use
   */
  const flattenArray = (arr) => {
    if (!Array.isArray(arr) || arr.length === 0) return {};

    if (Array.isArray(arr[0])) {
      return Object.assign({}, ...arr);
    } else if (typeof arr[0] === "object") {
      return Object.assign({}, ...arr);
    }

    return arr;
  };

  // Check if experiences exist and are not empty
  const hasExperiences =
    experiences && Array.isArray(experiences) && experiences.length > 0;
    console.log(experiences)
    window.xxx  = experiences

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    return `${month} ${year}`;
  };

  if (!hasExperiences) {
    return null;
  }

  return (
    <section className="experience min-h-max p-6 my-2 flex flex-col charming-portfolio-container-w">
      <div className="section-title simrev-up" ref={(el) => el && thisDivs.current.push(el)}>
            <Badge badgeTitle={"Experience"} />
        <p>Here is a quick summary of my most recent experiences:</p>
      </div>
      {experiences.map((singleExperience, index) => {
        //const flattenedExperience = flattenArray(singleExperience);
        const flattenedExperience = singleExperience;

        // Skip if empty after flattening
        if (
          !flattenedExperience ||
          Object.keys(flattenedExperience).length === 0
        ) {
          return null;
        }

        const startDate = flattenedExperience.start_date
          ? formatDate(flattenedExperience.start_date)
          : "";

        const workingNow = flattenedExperience.working || "off";
        const endDate = flattenedExperience.end_date
          ? formatDate(flattenedExperience.end_date)
          : "";

        const endDateStatus =
          workingNow.toLowerCase() === "on" ? "Present" : endDate;

        // Process the responsibility field with special tags
        const responsibility = flattenedExperience.responsibility
          ? specialTag(flattenedExperience.responsibility)
          : "";

        return (
          <div
            key={index}
            className="experience-content charming_portfolio_shadow_thin gap-y-3 simrev-up"
            tabIndex="0"
            ref={(el) => el && thisDivs.current.push(el)}
          >
            <div className="experience-name flex justify-center items-center">
              <h2 className="text-3xl">{flattenedExperience.institution}</h2>
            </div>
            <div className="experience-info experience-name flex flex-col justify-center gap-y-1">
              <h3 className="text-xl text-left">
                {flattenedExperience["post-title"]}
              </h3>

              {responsibility && (
                <p dangerouslySetInnerHTML={{ __html: responsibility }} />
              )}

              {startDate && (
                <h4 className="experience-time">
                  {`${startDate} - ${endDateStatus}`}
                </h4>
              )}
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default Experience;
